import { gql } from '@apollo/client'

import { PERMISSION_FRAGMENT } from './PermissionFragment'

export const LOGGED_IN_USER_FRAGMENT = gql`
  fragment LoggedInUser on User {
    uuid
    id
    email
    name
    firstName
    lastName
    username
    isStaff
    isSuperuser
    isActive
    mainRole
    roles
    dateRemoved
    companyName
    permissions {
      ...Permission
    }
  }
  ${PERMISSION_FRAGMENT}
`
